import { camelCase } from "lodash";
import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Field } from "formik";
import { SearchableList, FieldDropSide } from "../../../../components";
import authService from "../../../../components/api-authorization/AuthorizeService";
import permissions from "../../../../mocks/menuPermissions.json";
import { getAdvancedPathWithParam, ROUTES } from "../../../../utils";
import { useHistory } from "react-router";
const PayrollFundingHeader = ({
  title,
  subtitle,
  optionList = [],
  menu,
  subMenu,
  fundingType,
  classificationType,
  setclassificationType,
  isViewByDisabled,
}) => {
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const history = useHistory();
  const cancelNavigate = () => {
    history.push(
      getAdvancedPathWithParam({
        path: ROUTES.PAYROLL,
        // pathParam: [FLOW_TYPES.ADD],
      })
    );
  };
  return (
    <>
      {/* <p className="mt-20 payroll-submission-heading">{title}</p>
      <div className="border-top" /> */}
      <div
        className="d-flex mb-3 justify-content-end"
        style={{ marginTop: "-20px" }}
      >
        {/* <div className="font-weight-500" style={{ marginBottom: "30px" }}>
          {subtitle}
        </div> */}
        <div>
          {/* {permissions[roleName][menu + "SubMenu"][
            camelCase(subMenu)
          ]?.includes("U") && classificationType === "File" ? ( */}

          <Button variant="secondary" onClick={() => cancelNavigate()}>
            Cancel
          </Button>

          {classificationType == "File" && (
            <Button variant="primary" type="submit" className="ml-3">
              Submit
            </Button>
          )}
          {/* ) : null} */}
        </div>
      </div>
      <div className="border-top" />
      <Field
        isRequired
        label="View by"
        value={classificationType}
        size="smd"
        direction="bottom"
        options={optionList.map((_, index) => ({
          label: _.label,
          value: _.value,
        }))}
        disabled={true}
        popupContent={
          <SearchableList
            label=" "
            options={optionList.map((_, index) => ({
              label: _.label,
              value: _.value,
            }))}
            onSelect={(value) => {
              setclassificationType(value);
            }}
            selectedValue={classificationType}
          />
        }
        component={FieldDropSide}
      />
    </>
  );
};

export default PayrollFundingHeader;
